module.exports = __webpack_public_path__ + "static/media/AW_HP_EN_766x844_Lemonade.f31b4b76.mp4";